<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="机构编号/机构名称/机构负责人搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-allow="'actAdd'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                $emit('openEditFormDialog', {
                  type: 'add',
                  params: { classLevel: -1 },
                })
              "
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      title="高级搜索"
      show-close
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-form-item label="机构编号">
            <el-col :span="24">
              <el-input
                v-model.trim="form.orgNo"
                placeholder="请输入机构编号"
                clearable
              >
              </el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="机构名称">
            <el-col :span="24">
              <el-input
                v-model.trim="form.orgName"
                placeholder="请输入机构名称"
                clearable
              >
              </el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="机构全称">
            <el-col :span="24">
              <el-input
                v-model.trim="form.orgFullName"
                placeholder="请输入机构全称"
                clearable
              >
              </el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="负责人">
            <el-col :span="24">
              <el-input
                v-model.trim="form.orgLeader"
                placeholder="请输入机构负责人"
                clearable
              >
              </el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="可用状态">
            <el-col :span="24">
              <el-checkbox-group v-model="form.listOrgStatus">
                <el-checkbox label="Y">有效</el-checkbox>
                <el-checkbox label="N">无效</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          取消查询
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          重置条件
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          数据检索
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listOrgStatus: ['Y'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
</style>
